/**
 * Small helper to update document.title and meta description per route (SPA).
 * Emits SEO-friendly per-page meta tags without introducing react-helmet.
 */
export function setPageMeta({ title, description, canonical }) {
    if (title) document.title = title;

    if (description) {
        let el = document.querySelector('meta[name="description"]');
        if (!el) {
            el = document.createElement("meta");
            el.setAttribute("name", "description");
            document.head.appendChild(el);
        }
        el.setAttribute("content", description);

        // Open Graph description
        let og = document.querySelector('meta[property="og:description"]');
        if (!og) {
            og = document.createElement("meta");
            og.setAttribute("property", "og:description");
            document.head.appendChild(og);
        }
        og.setAttribute("content", description);
    }

    if (title) {
        let ogt = document.querySelector('meta[property="og:title"]');
        if (!ogt) {
            ogt = document.createElement("meta");
            ogt.setAttribute("property", "og:title");
            document.head.appendChild(ogt);
        }
        ogt.setAttribute("content", title);
    }

    if (canonical) {
        let link = document.querySelector('link[rel="canonical"]');
        if (!link) {
            link = document.createElement("link");
            link.setAttribute("rel", "canonical");
            document.head.appendChild(link);
        }
        link.setAttribute("href", canonical);

        let ogu = document.querySelector('meta[property="og:url"]');
        if (!ogu) {
            ogu = document.createElement("meta");
            ogu.setAttribute("property", "og:url");
            document.head.appendChild(ogu);
        }
        ogu.setAttribute("content", canonical);
    }
}
